<template>
	<div>
		<div class="filter-panel mt-2 mb-3">
			<div class="filter-panel__body">
				<v-row dense align="center">
					<v-col cols="12" lg="3" md="5" sm="12">
						<div class="filter-field-wrap">
							<s-select-definition :def="1253" v-model="filter.LocalityID" clearable
								hide-details></s-select-definition>
						</div>
					</v-col>
					<v-col cols="12" lg="3" md="5" sm="12">
						<div class="filter-field-wrap">
							<s-select-definition :def="1229" v-model="filter.TypeTransport" clearable
								hide-details></s-select-definition>
						</div>
					</v-col>
				</v-row>
			</div>
		</div>

		<s-crud style="display: none;" :config="config" :filter="filter" edit remove add @save="save($event)"
			search-input @addEvent="addEvent()" title="Configuración de Precios" @rowSelected="rowSelected($event)"
			ref="crudprice" height="540px">

			<template v-slot:filter><!-- filtros movidos fuera del s-crud --></template>

			<template slot-scope="props">
				<v-container fluid class="">
					<v-row dense>
						<v-col cols="12" lg="3" md="4" sm="12">
							<s-select-definition v-model="form.TypeTransport" label="Tipo de carga" :def="1229">
							</s-select-definition>
						</v-col>
						<v-col cols="12" lg="3" md="4" sm="12" v-if="form.TypeTransport != 5">
							<s-select-definition label="Localidad" :def="1253"
								v-model="form.LocaleID"></s-select-definition>
						</v-col>
						<v-col cols="12" lg="3" md="4" sm="12">
							<s-select label="Tipo de cálculo de precio" :items="TypeCalculates" item-text="text"
								item-value="value" v-model="form.TypeCalculate" />
						</v-col>

						<v-col cols="12" lg="3" md="4" sm="12" v-if="form.TypeCalculate == 'fijo_zona'">
							<s-select label="Zona Fija" :items="ZonesGroup" autocomplete item-text="ZonName"
								item-value="ZonID" v-model="form.ZonID" clearable />
						</v-col>

						<v-col cols="12" lg="3" md="4" sm="12"
							v-if="!['jaba_escalonado', 'fijo_zona', 'trasbordo'].includes(form.TypeCalculate)">
							<s-select-definition :def="1198" v-model="form.TypeVehicle" label="Tipo de vehículo"
								clearable />
						</v-col>

						<v-col cols="12" lg="3" md="4" sm="12" v-if="form.TypeTransport == 1">
							<!-- && !['jaba_escalonado'].includes(form.TypeCalculate) -->
							<s-select-definition v-model="form.TypeCultive" label="Tipo de cultivo" :def="1173"
								clearable>
							</s-select-definition>
						</v-col>

						<v-col cols="12" lg="3" md="4" sm="12"
							v-if="['zona_vehiculo_km', 'personalizado_empaca'].includes(form.TypeCalculate)">
							<s-text label="Aplicar KM" v-model="form.Km" type="number"></s-text>
						</v-col>

						<v-col cols="12" lg="3" md="4" sm="12"
							v-if="['jaba_escalonado', 'trasbordo', 'personalizado_empaca'].includes(form.TypeCalculate)">
							<s-text label="Rango | Capacidad" v-model="form.Capacity" type="number"></s-text>
						</v-col>

						<v-col cols="12" lg="3" md="3">
							<s-text label="Precio" v-model="form.Price" type="decimal" step="0.01" :min="0.00"></s-text>
						</v-col>
						<template v-if="[1].includes(form.TypeTransport)">
							<v-col cols="12" lg="3" md="3">
								<s-text label="Precio Adicional" v-model="form.PriceAditional" type="decimal"
									step="0.01" :min="0.00"></s-text>
							</v-col>
						</template>

						<v-col cols="12" lg="3" md="4" sm="12"
							v-if="!['personalizado_empaca'].includes(form.TypeCalculate)">
							<v-switch label="¿El precio incluye IGV?" v-model="form.IncludeIGV" hide-details
								class="mt-0" :true-value="1" :false-value="0" color="primary"></v-switch>
						</v-col>

						<v-col cols="12" lg="3" md="4" sm="12" v-if="form.TypeCalculate == 'personalizado_empaca'">
							<s-text label="Empaca" v-model="form.Empaca" type="text"></s-text>
						</v-col>
					</v-row>
				</v-container>
			</template>


			<template v-slot:item.Options="{ item }">
				<v-btn icon color="primary" @click="openRateModal(item)">
					<v-icon>mdi-cogs</v-icon>
				</v-btn>
			</template>

			<template v-slot:item.TypeTransportName="{ item }">
				{{ item.TypeTransportName }}
				<span class="font-weight-semibold" v-if="item.TypeTransport == 1">{{ item.TypeCultiveName }}</span>
				<v-chip v-if="item.IncludeIGV == 1" outlined x-small label color="primary" dark>
					Incluye IGV
				</v-chip>
			</template>
			<template v-slot:item.TypeCalculate="{ item }">
				{{ getTypeCalculate(item.TypeCalculate)?.text }}
			</template>
		</s-crud>

		<!-- ============================================================
		     VISTA DE PRECIOS AGRUPADOS POR TIPO DE TRANSPORTE — CARDS
		     (No reemplaza el crud, complementa la visualización)
		============================================================ -->
		<v-container fluid class="pa-0" v-if="zonesCardData.length > 0">
			<div class="d-flex align-center mb-4">
				<v-icon color="primary" class="mr-2">mdi-truck-outline</v-icon>
				<span class="zone-cards-title">Precios por Tipo de Transporte</span>
				<span class="zone-cards-subtitle ml-3">{{ zonesCardData.length }} tipo(s) configurado(s)</span>
			</div>

			<v-row>
				<v-col v-for="(group, idx) in zonesCardData" :key="group.typeTransport + '_' + idx" cols="12" lg="4"
					md="6" sm="12">
					<v-card class="zone-card" elevation="0">
						<!-- Cabecera por tipo de transporte -->
						<v-card-title class="zone-card__header pa-0 d-flex align-center"
							:class="group.typeTransport == 1 ? 'zone-card__header--fruta' : 'zone-card__header--material'">
							<v-avatar size="36" color="rgba(255,255,255,0.2)"
								class="ml-3 mr-3 flex-shrink-0 rounded-lg">
								<v-icon color="white" size="20">
									{{ group.typeTransport == 1 ? 'mdi-truck' : 'mdi-truck-fast' }}
								</v-icon>
							</v-avatar>
							<div class="flex-grow-1 overflow-hidden d-flex flex-column justify-center"
								style="min-width: 0;">
								<div class="zone-card__zone-name white--text font-weight-black text-uppercase letter-spacing-1 text-truncate"
									style="font-size: 14px; width: 100%;">
									{{ group.typeTransportName }}
								</div>
								<div class="white--text font-weight-medium opacity-80"
									style="font-size: 10px; line-height: 1.2;">
									{{ group.items.length }} precio{{ group.items.length !== 1 ? 's' : '' }}
									registrado{{
										group.items.length !== 1 ? 's' : '' }}
								</div>
							</div>
							<v-btn small icon dark class="mr-2 ml-2"
								:title="'Agregar precio para ' + group.typeTransportName"
								@click="openAddPriceDialog(group)">
								<v-icon size="20">mdi-plus-circle</v-icon>
							</v-btn>
						</v-card-title>

						<!-- Lista de precios dentro del grupo -->
						<v-card-text class="zone-card__body pa-0">
							<v-list dense class="pa-0">
								<template v-for="(section, sIdx) in group.sections">
									<!-- Subcabecera nativa de Vuetify para separación -->
									<v-subheader :key="'h-' + sIdx" class="grey lighten-4"
										style="height: 32px; font-size: 11px; font-weight: 800; text-transform: uppercase; letter-spacing: 0.5px;">
										<v-icon x-small :color="section.color" class="mr-2">{{ section.icon }}</v-icon>
										<span :class="section.color + '--text'">{{ section.title }}</span>
										<v-spacer></v-spacer>
										<span class="grey--text text--darken-1">{{ section.items.length }}</span>
									</v-subheader>

									<v-list-item v-for="(price, pIdx) in section.items" :key="'p-' + sIdx + '-' + pIdx"
										class="price-row pa-2 d-flex align-start justify-space-between"
										:class="{ 'price-row--old': price.IncludeIGV == 0 }"
										@dblclick="openEditPriceDialog(price)" title="Doble clic para editar">

										<!-- Información Izquierda -->
										<div class="flex-grow-1 overflow-hidden pa-1 px-2 d-flex flex-column"
											style="min-width: 0;">
											<!-- Localidad -->
											<div
												class="d-flex align-center flex-wrap text-body-2 font-weight-bold grey--text text--darken-3 mb-1">
												<v-icon size="14" class="mr-1" color="primary">mdi-map-marker</v-icon>
												{{ price.LocaleName || '—' }}
												<span v-if="price.ZoneName"
													class="grey--text text--darken-1 font-weight-medium ml-1">
													 · {{ price.ZoneName }}</span>
											</div>

											<!-- Tipo de Cálculo -->
											<div
												class="d-flex align-center text-caption grey--text text--darken-1 mb-1">
												<v-icon size="12" class="mr-1">mdi-calculator-variant</v-icon>
												{{ getTypeCalculate(price.TypeCalculate)?.text || price.TypeCalculate }}
											</div>

											<!-- Metadatos (Vehículo, Cultivo, Km, Capacidad, Empaca) -->
											<div class="d-flex align-center flex-wrap mt-1" style="gap: 8px;"
												v-if="price.TypeVehicleName || price.TypeCultiveName || price.Km || price.Capacity || price.Empaca">
												<span v-if="price.TypeCultiveName"
													class="d-flex align-center text-caption grey--text">
													<v-icon size="11" class="mr-1"
														color="grey darken-1">mdi-sprout</v-icon>
													{{ price.TypeCultiveName }}
												</span>
												<span v-if="price.TypeVehicleName"
													class="d-flex align-center text-caption grey--text">
													<v-icon size="11" class="mr-1"
														color="grey darken-1">mdi-car</v-icon>
													{{ price.TypeVehicleName }}
												</span>
												<span v-if="price.Km"
													class="d-flex align-center text-caption grey--text text-truncate">
													<v-icon size="11" class="mr-1"
														color="grey darken-1">mdi-map-marker-distance</v-icon>
													{{ price.Km }} km
												</span>
												<span v-if="price.Capacity"
													class="d-flex align-center text-caption grey--text">
													<v-icon size="11" class="mr-1"
														color="grey darken-1">mdi-package-variant</v-icon>
													Cap. {{ price.Capacity }}
												</span>
												<span v-if="price.Empaca"
													class="d-flex align-center text-caption indigo--text font-weight-bold">
													<v-icon size="11" class="mr-1" color="indigo">mdi-account</v-icon>
													{{ price.Empaca }}
												</span>
											</div>
										</div>

										<!-- Información Derecha (Precio y Acciones) -->
										<div class="d-flex flex-column align-end pa-1 px-2 flex-shrink-0"
											style="min-width: 80px;">
											<div class="text-body-1 font-weight-black primary--text"
												style="line-height: 1.2;">
												S/ {{ Number(price.Price).toFixed(2) }}
											</div>
											<div class="text-caption warning--text darken-2 font-weight-bold"
												v-if="price.PriceAditional && Number(price.PriceAditional) > 0">
												+S/ {{ Number(price.PriceAditional).toFixed(2) }}
											</div>
											<v-chip v-if="price.IncludeIGV == 1" x-small label color="primary" dark
												class="mt-1 px-1 rounded-md">
												Incluye IGV
											</v-chip>
											<v-btn icon x-small color="error" class="mt-1" title="Eliminar precio"
												@click.stop="deleteFromCard(price)">
												<v-icon size="14">mdi-trash-can-outline</v-icon>
											</v-btn>
										</div>
									</v-list-item>
									<v-divider v-if="sIdx < group.sections.length - 1" :key="'d-' + sIdx"></v-divider>
								</template>
							</v-list>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
		</v-container>

		<!-- ============================================================
		     DIALOG: AGREGAR PRECIO POR TIPO DE TRANSPORTE
		============================================================ -->
		<v-dialog v-model="dialogAddPrice" max-width="700" persistent scrollable>
			<v-card class="rounded-xl overflow-hidden">
				<div class="header-premium py-3 px-3 header-content">
					<div class="header-left">
						<div class="icon-box mr-4 elevation-3 pa-2 rounded-lg primary darken-3">
							<v-icon size="28" color="white">
								{{ isEditMode ? 'mdi-pencil' : 'mdi-tag-plus' }}
							</v-icon>
						</div>
						<h2 class="white--text flex-grow-1 text-h6 font-weight-black text-uppercase letter-spacing-1">
							{{ isEditMode ? 'Editar Precio' : 'Nuevo Precio' }}
						</h2>
					</div>
					<div class="header-actions">
						<v-btn icon large class="close-btn" @click="dialogAddPrice = false">
							<v-icon color="white">mdi-close</v-icon>
						</v-btn>
					</div>
				</div>

				<!-- FORMULARIO GUIADO POR SECCIONES -->
				<v-card-text class="add-price-dialog__body">

					<!-- === SECCIÓN 1: CONFIGURACIÓN BASE === -->
					<v-sheet rounded outlined class="form-section mb-4 mt-4">
						<div class="form-section__label">
							<v-avatar size="24" color="#3b82f6" class="form-section__num"><span>1</span></v-avatar>
							<span>Configuración Base</span>
						</div>
						<v-row dense>
							<v-col cols="12" md="6">
								<s-select-definition v-model="form.TypeTransport" label="Tipo de Transporte"
									:def="1229">
								</s-select-definition>
							</v-col>
							<v-col cols="12" md="6" v-if="form.TypeTransport != 5">
								<s-select-definition label="Localidad" :def="1253"
									v-model="form.LocaleID"></s-select-definition>
							</v-col>
							<v-col cols="12" md="6" v-if="form.TypeTransport == 1">
								<!-- Solo aplica cuando el tipo de transporte es Fruta -->
								<s-select-definition v-model="form.TypeCultive" label="Tipo de Cultivo" :def="1173"
									clearable>
								</s-select-definition>
							</v-col>
						</v-row>
					</v-sheet>

					<!-- === SECCIÓN 2: TIPO DE CÁLCULO === -->
					<v-sheet rounded outlined class="form-section form-section--calc mb-4">
						<div class="form-section__label">
							<v-avatar size="24" color="#7c3aed" class="form-section__num"><span>2</span></v-avatar>
							<span>Tipo de Cálculo</span>
						</div>

						<!-- Selector de tipo con v-btn-toggle -->
						<v-btn-toggle v-model="form.TypeCalculate" class="calc-type-grid"
							active-class="calc-type-chip--active" background-color="transparent" color="primary" group>
							<v-btn v-for="tc in TypeCalculates" :key="tc.value" :value="tc.value" class="calc-type-chip"
								text>
								<v-icon size="28" class="calc-type-chip__icon">{{ calcTypeIcon(tc.value) }}</v-icon>
								<span class="calc-type-chip__text">{{ tc.text }}</span>
							</v-btn>
						</v-btn-toggle>

						<!-- Parámetros condicionales según el tipo elegido -->
						<v-row dense class="mt-2" v-if="form.TypeCalculate">
							<!-- Zona fija -->
							<v-col cols="12" md="6" v-if="form.TypeCalculate == 'fijo_zona'">
								<div class="param-hint"><v-icon size="13"
										color="#6366f1">mdi-information-outline</v-icon>
									Selecciona la zona a la que aplica el precio fijo</div>
								<s-select label="Zona Fija" :items="ZonesGroup" autocomplete item-text="ZonName"
									item-value="ZonID" v-model="form.ZonID" clearable />
							</v-col>

							<!-- Tipo vehículo (no aplica en ciertos cálculos) -->
							<v-col cols="12" md="6"
								v-if="!['jaba_escalonado', 'fijo_zona', 'trasbordo'].includes(form.TypeCalculate)">
								<div class="param-hint"><v-icon size="13"
										color="#6366f1">mdi-information-outline</v-icon>
									Vehículo al que aplica este precio</div>
								<s-select-definition :def="1198" v-model="form.TypeVehicle" label="Tipo de Vehículo"
									clearable />
							</v-col>

							<!-- KM (zona_vehiculo_km / personalizado_empaca) -->
							<v-col cols="12" md="6"
								v-if="['zona_vehiculo_km', 'personalizado_empaca'].includes(form.TypeCalculate)">
								<div class="param-hint"><v-icon size="13"
										color="#6366f1">mdi-information-outline</v-icon>
									Distancia en km que recorre el vehículo</div>
								<s-text label="Kilómetros (KM)" v-model="form.Km" type="number"></s-text>
							</v-col>
							<!-- Capacidad / Rango (jaba_escalonado, trasbordo, personalizado_empaca) -->
							<v-col cols="12" md="6"
								v-if="['jaba_escalonado', 'trasbordo', 'personalizado_empaca'].includes(form.TypeCalculate)">
								<div class="param-hint"><v-icon size="13"
										color="#6366f1">mdi-information-outline</v-icon>
									{{
										form.TypeCalculate === 'trasbordo' ?
											'Número máximo de vueltas para este rango' : 'Número de jabas / unidades del rango'
									}}
								</div>
								<s-text label="Rango / Capacidad" v-model="form.Capacity" type="number"></s-text>
							</v-col>

							<!-- Empaca (personalizado_empaca) -->
							<v-col cols="12" md="6" v-if="form.TypeCalculate == 'personalizado_empaca'">
								<div class="param-hint"><v-icon size="13"
										color="#6366f1">mdi-information-outline</v-icon>
									Nombre o código del empacador al que aplica</div>
								<s-text label="Empaca" v-model="form.Empaca" type="text"></s-text>
							</v-col>
						</v-row>
					</v-sheet>

					<!-- === SECCIÓN 3: PRECIOS === -->
					<v-sheet rounded outlined class="form-section form-section--price">
						<div class="form-section__label">
							<v-avatar size="24" color="#16a34a" class="form-section__num">
								<span>3</span>
							</v-avatar>
							<span>Precios</span>
						</div>
						<v-row dense>
							<v-col cols="12" :md="[1].includes(form.TypeTransport) ? 6 : 8">
								<div class="param-hint"><v-icon size="13" color="#16a34a">mdi-currency-usd</v-icon>
									Precio
									principal del transporte (S/)</div>
								<s-text label="Precio (S/)" v-model="form.Price" type="decimal" step="0.01"
									:min="0.00"></s-text>
							</v-col>
							<v-col cols="12" md="6" v-if="[1].includes(form.TypeTransport)">
								<div class="param-hint"><v-icon size="13"
										color="#f59e0b">mdi-plus-circle-outline</v-icon>
									Precio adicional por fruta (S/)</div>
								<s-text label="Precio Adicional (S/)" v-model="form.PriceAditional" type="decimal"
									step="0.01" :min="0.00"></s-text>
							</v-col>
							<v-col cols="12" v-if="!['personalizado_empaca'].includes(form.TypeCalculate)">
								<div class="igv-premium-toggle px-4 py-3 rounded-xl border d-flex align-center mt-2">
									<div class="igv-icon-box mr-4 indigo lighten-5 rounded-lg pa-2">
										<v-icon color="indigo">mdi-calculator-variant-outline</v-icon>
									</div>
									<div class="flex-grow-1">
										<div
											class="text-caption font-weight-black indigo--text text-uppercase letter-spacing-1 mb-1">
											Gestión de Impuestos</div>
										<div class="text-body-2 font-weight-bold grey--text text--darken-3">
											¿El precio ya incluye el IGV?
										</div>
									</div>
									<v-switch v-model="form.IncludeIGV" hide-details class="mt-0 pt-0 custom-switch"
										:true-value="1" :false-value="0" color="indigo" inset></v-switch>
								</div>
							</v-col>
						</v-row>
					</v-sheet>

				</v-card-text>

				<!-- Acciones -->
				<v-card-actions class="pa-3">
					<v-spacer />
					<v-btn color="red" @click="dialogAddPrice = false" class="rounded-lg white--text">
						<v-icon left size="18" color="white">mdi-close</v-icon>
						Cancelar
					</v-btn>
					<v-btn color="primary" depressed @click="saveFromDialog()" class="rounded-lg white--text">
						<v-icon left size="18" color="white">{{ isEditMode ? 'mdi-check' : 'mdi-content-save'
						}}</v-icon>
						{{ isEditMode ? 'Actualizar Precio' : 'Guardar Precio' }}
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>
<script>

import _sTransportPriceService from "../../../services/Technicalassistance/TransportPriceService";
import _sTasGroupZonService from "../../../services/Technicalassistance/TasGroupZonService";
import _sTransportPriceRateService from "../../../services/Technicalassistance/TransportPriceRateService";

export default {
	components: {},
	data: () => ({
		checkRoute: true,
		objRoute: {},
		selected: {},
		filter: {
			// Search: "",
			LocalityID: 0,
			TypeTransport: 0
		},
		config: {
			service: _sTransportPriceService,
			model: {
				TcpID: "ID",
				Options: ""
			},
			headers: [
				{ text: "Local de Precio", value: "LocaleName", },
				{ text: "Transporte", value: "TypeTransportName", width: 120, align: 'left' },
				{ text: "Vehículo", value: "TypeVehicleName", width: 120, align: 'center' },
				{ text: "Tipo Calculo", value: "TypeCalculate", width: 160, align: 'left' },
				{ text: "Zona Aplicada", value: "ZoneName", width: 120, align: 'center' },
				{ text: "Distancia Km", value: "Km", width: 120, align: 'center' },
				{ text: "Rango Cantidad", value: "Capacity", width: 150, align: 'center' },
				{ text: "Precio", value: "Price", width: 70, align: 'center' },
				{ text: "Precio Adicional", value: "PriceAditional", width: 100, align: 'center' },
				{ text: "Empaca", value: "Empaca", width: 80, align: 'center' },
			],
		},
		applySameLocale: true,
		dialogRate: false,
		filterRate: {
			TcpID: 0,
			// Search: ""
		},
		configRate: {
			service: _sTransportPriceRateService,
			model: {
				TrrID: "ID",
				TcpID: "int",
				InitialValue: "int",
				EndValue: "int",
				Code: "Code",
				Price: "decimal",
				PriceAditional: "decimal",
			},
			headers: [
				{ text: "Rango Inicio", value: "InitialValue" },
				{ text: "Rango Final", value: "EndValue" },
				{ text: "Medida Rango", value: "Code", align: 'center' },
				{ text: "Precio", value: "Price", align: 'center' },
				{ text: "Precio Adicional", value: "PriceAditional", align: 'center' },
			],
		},
		formRate: {
			TrrID: 0,
			TcpID: 0,
			InitialValue: 0,
			EndValue: 0,
			Code: "",
			Price: 0.0,
			PriceAditional: 0.0,
			SecStatus: 1,
			UsrCreateID: null
		},
		form: {
			TcpID: 0,
			TypeTransport: null,
			LocaleID: null,
			ZonID: null,
			TypeCalculate: null,
			TypeVehicle: null,
			TypeCultive: null,
			IncludeIGV: 1,
			Km: null,
			Capacity: null,
			Empaca: null,
			Price: 0.0,
			PriceAditional: 0.0,
			SecStatus: 1,
			UsrCreateID: null//this.$fun.getUserID(),
		},
		ZonesGroup: [],
		crudItems: [],
		dialogAddPrice: false,
		dialogGroupName: '',
		TypeCalculates: [
			{ value: 'zona_vehiculo_km', text: "PRECIO POR KILÓMETROS DE ZONA VEHÍCULO", code: "KM" },
			{ value: 'fijo_vehiculo', text: "PRECIO FIJO POR VEHÍCULO", code: "VEHICULO_FIJO" },
			{ value: 'fijo_zona', text: "PRECIO FIJO POR ZONA", code: "ZONA_FIJO" },
			{ value: 'jaba_escalonado', text: "PRECIO POR JABA ESCALONADO", code: "JABA" },
			{ value: 'trasbordo', text: "PRECIO POR NÚMERO DE VUELTAS", code: "TRABORDO" },
			{ value: 'personalizado_empaca', text: "PRECIO PERSONALIZADO POR EMPACA", code: "EMPACA" },
		]
	}),
	computed: {
		zonesCardData() {
			const groups = {};
			this.crudItems.forEach(item => {
				const key = String(item.TypeTransport);
				if (!groups[key]) {
					groups[key] = {
						typeTransport: item.TypeTransport,
						typeTransportName: item.TypeTransportName || 'Sin Tipo',
						items: []
					};
				}
				groups[key].items.push(item);
			});
			return Object.values(groups).map(group => {
				// Categorizar dentro de cada grupo de transporte
				const normal = group.items.filter(i => (i.IncludeIGV == 1) && (!i.Empaca || i.Empaca == ''));
				const empaca = group.items.filter(i => i.Empaca && i.Empaca != '');
				const antiguos = group.items.filter(i => i.IncludeIGV == 0);

				const sections = [];
				if (normal.length > 0) sections.push({ title: 'Precios con IGV Incluido', items: normal, icon: 'mdi-check-circle', color: 'success' });
				if (empaca.length > 0) sections.push({ title: 'Configuración por Empacadora', items: empaca, icon: 'mdi-factory', color: 'indigo' });
				if (antiguos.length > 0) sections.push({ title: 'Precios Vigentes / Sin IGV', items: antiguos, icon: 'mdi-receipt-check', color: 'primary' });

				return {
					...group,
					sections
				};
			});
		},
		isEditMode() {
			return this.form.TcpID > 0;
		}
	},
	watch: {
		filter: {
			handler() {
				this.loadZoneCardData();
			},
			deep: true
		},
		"form.TypeCalculate": {
			handler(val) {
				this.form.ZonID = null;
				if (val == 'fijo_zona') {
					this.getZonesGroup();
				} else {
					this.ZonesGroup = [];
				}
			}
		},
		"form.LocaleID": {
			handler(val) {
				this.form.ZonID = null;
				if (this.form.TypeCalculate == 'fijo_zona') {
					this.getZonesGroup();
				} else {
					this.ZonesGroup = [];
				}
			}
		}
	},
	methods: {
		addEvent() {
			this.reset();
		},
		addEventRate() {
			this.resetRate();
		},
		openAddPriceDialog(group) {
			this.reset();
			this.form.TypeTransport = group.typeTransport;
			this.dialogGroupName = group.typeTransportName;
			this.dialogAddPrice = true;
		},
		openEditPriceDialog(price) {
			this.reset();
			this.form = { ...price };
			this.dialogGroupName = price.TypeTransportName || '';
			// Si el tipo de calculo es fijo_zona, cargar las zonas
			if (this.form.TypeCalculate === 'fijo_zona') {
				this.getZonesGroup();
			}
			this.dialogAddPrice = true;
		},
		saveFromDialog() {
			this.save(() => {
				this.dialogAddPrice = false;
			});
		},
		deleteFromCard(price) {
			this.$fun.alert("¿Confirma eliminar este precio?", "question").then(confirm => {
				if (confirm.value) {
					const payload = { ...price, SecStatus: 0, UsrCreateID: this.$fun.getUserID() };
					_sTransportPriceService.save(payload, this.$fun.getUserID()).then(response => {
						if (response.status == 200) {
							this.$refs.crudprice.refresh();
							this.$fun.alert("Precio eliminado correctamente", "success");
							this.loadZoneCardData();
						}
					}).catch(error => console.log({ error }));
				}
			});
		},
		rowSelected(item) {
			if (item.length > 0) {
				this.selected = { ...item[0] };
				this.form = { ...item[0] };
				this.filterRate.TcpID = this.form.TcpID;
			}
		},
		rowSelectedRate(item) {
			if (item.length > 0) {
				this.formRate = { ...item[0] };
			}
		},
		save(onSuccess) {

			if (this.form.TypeTransport == null) {
				this.$fun.alert("Seleccione tipo de transporte", "warning")
				return;
			}

			if (this.form.TypeTransport == 5) {
				this.form.LocaleID = 1;
				this.form.ZonID = null;
			}

			// if ([1, 2].includes(this.form.TypeTransport)) {
			if (this.form.LocaleID == null) {
				this.$fun.alert("Seleccione Localidad aplicar precios", "warning")
				return;
			}

			if (this.form.TypeCalculate == null) {
				this.$fun.alert("Seleccione tipo de calculo", "warning")
				return;
			}

			if (this.form.TypeCalculate == 'fijo_zona' && this.form.ZonID == null) {
				this.$fun.alert("Seleccione zona aplicar precio", "warning")
				return;
			}

			if (['fijo_vehiculo', 'personalizado_empaca'].includes(this.form.TypeCalculate) && this.form.TypeVehicle == null) {
				this.$fun.alert("Seleccione tipo de vehiculo", "warning")
				return;
			}

			if (this.form.TypeTransport == 1 && this.form.TypeCultive == null) {
				// (!['jaba_escalonado'].includes(this.form.TypeCalculate)) &&
				this.$fun.alert("Seleccione tipo de cultivo", "warning")
				return;
			}

			if (['jaba_escalonado', 'trasbordo', 'personalizado_empaca'].includes(this.form.TypeCalculate) && this.form.Capacity == null) {
				this.$fun.alert("Ingrese rango de capacidad", "warning")
				return;
			}

			if (['zona_vehiculo_km', 'personalizado_empaca'].includes(this.form.TypeCalculate) && this.form.Km == null) {
				this.$fun.alert("Ingrese kilometros de distancia", "warning")
				return;
			}

			if (this.form.Price <= 0) {
				this.$fun.alert("Ingrese precio válido", "warning")
				return;
			}

			if (this.form.PriceAditional < 0) {
				this.$fun.alert("Ingrese precio adicional", "warning")
				return;
			}

			if (['personalizado_empaca'].includes(this.form.TypeCalculate) && this.form.Empaca == null) {
				this.$fun.alert("Ingrese descripción de empaca", "warning")
				return;
			}

			if (['zona_vehiculo_km', 'personalizado_empaca'].includes(this.form.TypeCalculate) && this.form.Km <= 0) {
				this.$fun.alert("Ingresar la distancia de Kilometros del precio", "warning")
				return;
			}

			if (!['zona_vehiculo_km', 'personalizado_empaca'].includes(this.form.TypeCalculate)) {
				this.form.Km = null;
			}

			if (!['jaba_escalonado', 'trasbordo', 'personalizado_empaca'].includes(this.form.TypeCalculate)) {
				this.form.Capacity = null;
			}

			if (!['personalizado_empaca'].includes(this.form.TypeCalculate)) {
				this.form.Empaca = null;
			}

			if (['jaba_escalonado', 'fijo_zona', 'trasbordo'].includes(this.form.TypeCalculate)) {
				this.form.TypeVehicle = null;
			}

			if (!['personalizado_empaca'].includes(this.form.TypeCalculate)) {
				this.form.Empaca = null;
			}

			if (!['zona_vehiculo_km', 'personalizado_empaca'].includes(this.form.TypeCalculate)) {
				this.form.Km = null;
			}



			this.form.SecStatus = 1;
			this.form.UsrCreateID = this.$fun.getUserID();
			this.form.Code = [
				this.form.TypeTransport,
				this.form.LocaleID,
				this.form.Km,
				this.form.Capacity,
				this.form.TypeVehicle
			].filter(v => v != null && v != undefined && v != "").join("");


			if (['FIJO'].includes(this.getTypeCalculate(this.form.TypeCalculate)?.code) && this.form.TcpID <= 0) {
				if (this.form.Price == "" || this.form.Price <= 0) {
					this.$fun.alert("Ingrese precio", "warning")
					return;
				}
				if (Number(this.form.PriceAditional) < 0) {
					this.$fun.alert("Ingrese precio adicional", "warning")
					return;
				}

				// this.form.ConfigurationPriceRate = [
				// 	{
				// 		TrrID: 0,
				// 		TcpID: this.form.TcpID,
				// 		InitialValue: 0,
				// 		EndValue: 0,
				// 		Code: this.getTypeCalculate(this.form.TypeCalculate)?.code,
				// 		Price: this.form.Price,
				// 		PriceAditional: Number(this.form.PriceAditional),
				// 		SecStatus: 1,
				// 		UsrCreateID: this.$fun.getUserID()
				// 	}
				// ];
			}

			// console.log(this.form);
			_sTransportPriceService.save(this.form, this.$fun.getUserID()).then((response) => {
				if (response.status == 200) {
					this.$refs.crudprice.refresh();
					this.$fun.alert("Precio guardado correctamente", "success")
					this.reset();
					this.loadZoneCardData();
					if (typeof onSuccess === 'function') onSuccess();
				}
			}).catch(error => console.log({ error }));
		},
		getZonesGroup() {
			const parameters = { TypeZon: this.form.LocaleID }
			_sTasGroupZonService.GetZonesByGroup(parameters, this.$fun.getUserID()).then((response) => {
				this.ZonesGroup = response.status == 200 ? response.data : [];
			});
		},
		openRateModal(item) {
			this.form = { ...item };
			this.filterRate.TcpID = item.TcpID;
			this.dialogRate = true;
		},
		saveRate() {
			// 'precio_fijo_vehiculo', 'precio_fijo_zona'
			if (['por_km', 'por_jaba_escalonado', 'por_vuelta'].includes(this.form.TypeCalculate)) {
				if (this.formRate.InitialValue < 0) {
					this.$fun.alert("Valor inicial debe de mayor o igual a 0", "warning")
					return;
				}
				if (this.formRate.EndValue <= 0) {
					this.$fun.alert("Valor final debe de mayor a 0", "warning")
					return;
				}
				if (this.formRate.EndValue < this.formRate.InitialValue) {
					this.$fun.alert("Valor final debe de ser mayor al valor inicial", "warning")
					return;
				}
			}

			if (this.formRate.Price <= 0) {
				this.$fun.alert("Precio debe de mayor a 0", "warning")
				return;
			}
			if (this.formRate.PriceAditional < 0) {
				this.$fun.alert("Precio adicional debe de mayor a 0", "warning")
				return;
			}

			this.formRate.TcpID = this.form.TcpID;
			this.formRate.UsrCreateID = this.$fun.getUserID();
			this.formRate.Code = this.getTypeCalculate(this.form.TypeCalculate).code;
			// console.log(this.form);

			_sTransportPriceRateService.save(this.formRate, this.$fun.getUserID()).then((response) => {
				this.$refs.crudpricerate.refresh();
				this.$fun.alert("Tarifa guardada correctamente", "success");
				this.resetRate();
			});
		},
		reset() {
			this.applySameLocale = true;
			this.form = {
				TcpID: 0,
				TypeTransport: null,
				LocaleID: null,
				ZonID: null,
				TypeCalculate: null,
				TypeVehicle: null,
				TypeCultive: null,
				IncludeIGV: 1,
				Empaca: null,
				Price: 0.0,
				PriceAditional: 0.0,
				SecStatus: 1,
				UsrCreateID: this.$fun.getUserID()
			}
		},
		resetRate() {
			this.formRate = {
				TrrID: 0,
				TcpID: this.form.TcpID,
				InitialValue: 0,
				EndValue: 0,
				Code: this.getTypeCalculate(this.form.TypeCalculate)?.code,
				Price: 0.0,
				PriceAditional: 0.0,
				SecStatus: 1,
				UsrCreateID: null
			}
		},
		getTypeCalculate(value) {
			return this.TypeCalculates.find((item) => item.value == value);
		},
		calcTypeIcon(value) {
			const icons = {
				zona_vehiculo_km: 'mdi-map-marker-distance',
				fijo_vehiculo: 'mdi-truck',
				fijo_zona: 'mdi-map-marker-radius',
				jaba_escalonado: 'mdi-package-variant-closed',
				trasbordo: 'mdi-repeat',
				personalizado_empaca: 'mdi-account-hard-hat',
			};
			return icons[value] || 'mdi-calculator';
		},
		loadZoneCardData() {
			_sTransportPriceService.pagination(
				{ filter: this.filter, draw: 1, start: 0, length: 99999 },
				this.$fun.getUserID()
			).then(response => {
				if (response.status === 200) {
					this.crudItems = response.data?.data ?? response.data ?? [];
				}
			}).catch(() => { });
		}
	},
	created() {
		this.configZon = {
			url: _sTransportPriceService.GetZon(),
			title: this.label,
			params: { search: "", requestID: this.$fun.getUserID() },
		};
	},
	mounted() {
		this.loadZoneCardData();
	},
};
</script>


<style scoped>
/* =============================================
   ZONE CARDS SECTION
============================================= */
.header-premium {
	display: flex;
	justify-content: space-between;
	align-items: center;
	background: linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%);
	/* border-bottom: 4px solid #1e3a8a; */
}

.header-actions {
	display: flex;
	align-items: end;
	gap: 8px;
}

.header-left {
	display: flex;
	align-items: center;
	gap: 16px;
}

.zone-cards-section {
	background: #f8fafc;
	border-top: 2px solid #e2e8f0;
}

.zone-cards-title {
	font-size: 16px;
	font-weight: 700;
	color: #1e293b;
	letter-spacing: 0.3px;
}

.zone-cards-subtitle {
	font-size: 13px;
	color: #64748b;
	font-weight: 400;
}

/* =============================================
   ZONE CARD
============================================= */
.zone-card {
	background: #ffffff;
	border-radius: 14px;
	box-shadow: 0 2px 12px rgba(0, 0, 0, 0.07), 0 1px 3px rgba(0, 0, 0, 0.05);
	overflow: hidden;
	transition: box-shadow 0.25s ease, transform 0.2s ease;
	height: 100%;
}

.zone-card:hover {
	box-shadow: 0 8px 28px rgba(79, 142, 247, 0.18), 0 2px 8px rgba(0, 0, 0, 0.08);
	transform: translateY(-2px);
}

.zone-card__header {
	display: flex;
	align-items: center;
	gap: 12px;
	padding: 14px 16px;
	background: linear-gradient(135deg, #3b82f6 0%, #6366f1 100%);
}

.zone-card__icon-wrap {
	width: 36px;
	height: 36px;
	background: rgba(255, 255, 255, 0.2);
	border-radius: 8px;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
}

.zone-card__header-info {
	flex: 1;
	min-width: 0;
}

.zone-card__zone-name {
	font-size: 14px;
	font-weight: 700;
	color: #ffffff;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	letter-spacing: 0.3px;
}

.zone-card__locale {
	font-size: 11px;
	color: rgba(255, 255, 255, 0.75);
	margin-top: 2px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.zone-card__badge {
	background: rgba(255, 255, 255, 0.25);
	color: #ffffff;
	font-size: 11px;
	font-weight: 600;
	padding: 4px 10px;
	border-radius: 20px;
	white-space: nowrap;
	flex-shrink: 0;
}

/* =============================================
   PRICE ROWS
============================================= */
.zone-card__body {
	padding: 8px 0;
	max-height: 420px;
	overflow-y: auto;
	scrollbar-width: thin;
	scrollbar-color: #cbd5e1 transparent;
}

.zone-card__body::-webkit-scrollbar {
	width: 5px;
}

.zone-card__body::-webkit-scrollbar-track {
	background: transparent;
}

.zone-card__body::-webkit-scrollbar-thumb {
	background: #cbd5e1;
	border-radius: 10px;
}

.zone-card__body::-webkit-scrollbar-thumb:hover {
	background: #94a3b8;
}

.price-row {
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	gap: 12px;
	border-bottom: 1px solid #f1f5f9;
	transition: background 0.15s ease;
}

.price-row:last-child {
	border-bottom: none;
}

.price-row:hover {
	background: #f8faff;
}

.price-row--old {
	background: #fff7f7;
}

.price-row--old:hover {
	background: #fff0f0;
}

.price-row__left {
	flex: 1;
	min-width: 0;
}

.price-row__transport {
	font-size: 13px;
	font-weight: 600;
	color: #1e293b;
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 2px;
}

.price-row__cultive {
	color: #4f8ef7;
	font-weight: 500;
}

.price-row__type {
	font-size: 11px;
	color: #64748b;
	margin-top: 3px;
	display: flex;
	align-items: center;
}

.price-row__meta {
	display: flex;
	align-items: center;
	gap: 10px;
	margin-top: 4px;
	flex-wrap: wrap;
}

.price-row__meta span {
	font-size: 11px;
	color: #94a3b8;
	display: flex;
	align-items: center;
	gap: 2px;
}

.price-row__right {
	text-align: right;
	flex-shrink: 0;
}

.price-row__price {
	font-size: 16px;
	font-weight: 800;
	color: #16a34a;
	letter-spacing: -0.5px;
}

.price-row__price-add {
	font-size: 11px;
	color: #f59e0b;
	font-weight: 600;
	margin-top: 2px;
}

/* =============================================
   CARD HEADER COLOR VARIANTS
============================================= */
.zone-card__header--fruta {
	background: linear-gradient(135deg, #3b82f6 0%, #6366f1 100%);
}

.zone-card__header--material {
	background: linear-gradient(135deg, #f59e0b 0%, #f97316 100%);
}

.zone-card__add-btn {
	opacity: 0.85;
	transition: opacity 0.15s ease, transform 0.15s ease;
	flex-shrink: 0;
}

.zone-card__add-btn:hover {
	opacity: 1;
	transform: scale(1.15);
}

.price-row__zone {
	color: #8b5cf6;
	font-weight: 500;
}

/* =============================================
   ADD PRICE DIALOG
============================================= */

.add-price-dialog__header {
	display: flex;
	align-items: center;
	gap: 14px;
	padding: 8px 8px;
	background: linear-gradient(135deg, #3b82f6 0%, #6366f1 100%);
}

.add-price-dialog__icon {
	width: 42px;
	height: 42px;
	background: rgba(255, 255, 255, 0.2);
	border-radius: 10px;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
}

.add-price-dialog__title {
	font-size: 16px;
	font-weight: 700;
	color: #ffffff;
	line-height: 1.2;
}

.add-price-dialog__subtitle {
	font-size: 12px;
	color: rgba(255, 255, 255, 0.8);
	margin-top: 2px;
}

/* =============================================
   DIALOG BODY & SECTIONS
============================================= */
.add-price-dialog__body {
	padding: 12px;
	overflow-y: auto;
	max-height: 70vh;
}

.form-section {
	background: #f5f3ff;
	border: 1px solid #f5f3ff !important;
	border-radius: 1.5rem !important;
	padding: 8px;
	margin-bottom: 8px;
}

.form-section--calc {
	background: #f5f3ff;
	border-color: #ddd6fe;
}

.form-section--price {
	background: #f5f3ff;
	border-color: #ddd6fe;
}

.form-section__label {
	display: flex;
	align-items: center;
	gap: 10px;
	margin-bottom: 14px;
	font-size: 13px;
	font-weight: 700;
	color: #334155;
	letter-spacing: 0.4px;
	text-transform: uppercase;
}

.form-section__num {
	width: 24px;
	height: 24px;
	border-radius: 50%;
	background: #3b82f6;
	color: #fff;
	font-size: 12px;
	font-weight: 800;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
}

.form-section__num--calc {
	background: #7c3aed;
}

.form-section__num--price {
	background: #16a34a;
}

/* =============================================
   CALC TYPE CHIP GRID
============================================= */
.calc-type-grid {
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
}

.calc-type-chip {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 2px;
	padding: 8px 12px;
	border-radius: 10px;
	border: 2px solid #e2e8f0;
	background: #fff;
	color: #64748b;
	font-size: 10px;
	font-weight: 600;
	text-align: center;
	cursor: pointer;
	transition: all 0.18s ease;
	min-width: 96px;
	line-height: 1.3;
	user-select: none;
}

.calc-type-chip:hover {
	border-color: #a5b4fc;
	color: #4f46e5;
	background: #ede9fe;
}

.calc-type-chip--active {
	border-color: #6366f1;
	background: linear-gradient(135deg, #6366f1, #818cf8);
	color: #ffffff;
	box-shadow: 0 4px 12px rgba(99, 102, 241, 0.35);
}

/* =============================================
   PARAM HINTS
============================================= */
.param-hint {
	font-size: 11px;
	color: #64748b;
	margin-bottom: 4px;
	display: flex;
	align-items: center;
	gap: 4px;
	font-style: italic;
}

/* =============================================
   OLD PRICE TOGGLE
============================================= */
.old-price-toggle {
	display: flex;
	align-items: center;
	gap: 8px;
	background: #fff5f5;
	border: 1px solid #fecaca;
	border-radius: 8px;
	padding: 8px 14px;
	margin-top: 4px;
}

.old-price-toggle__label {
	font-size: 12px;
	color: #64748b;
	flex: 1;
}

/* Cursor pointer en price-row para indicar que es clicable */
.price-row {
	cursor: pointer;
}

/* =============================================
   VUETIFY COMPONENT OVERRIDES
   (mantiene el diseño exacto al migrar a componentes)
============================================= */

/* v-card como zone-card: neutralizar sombra propia de Vuetify */
.zone-card.v-card {
	border-radius: 14px !important;
}

/* v-card-title como header: resetear padding y font predeterminados */
.zone-card__header.v-card__title {
	font-size: inherit !important;
	font-weight: inherit !important;
	letter-spacing: inherit !important;
	line-height: inherit !important;
	padding: 14px 0 14px 0 !important;
	min-height: unset !important;
}

/* v-card-text como body: override de padding de Vuetify */
.zone-card__body.v-card__text {
	padding: 0 !important;
}

/* v-list dentro del body: sin fondo extra */
.zone-card__body .v-list {
	background: transparent !important;
}

/* v-list-item como price-row: override de padding de Vuetify */
.price-row.v-list-item {
	padding: 0 !important;
	min-height: unset !important;
	align-items: flex-start !important;
}

.price-row.v-list-item:before {
	display: none !important;
}


/* v-sheet como form-section: eliminar borde doble y respetar la classe */
.form-section.v-sheet {
	border: none !important;
}

/* v-avatar como form-section__num: texto centrado */
.form-section__num.v-avatar span {
	font-size: 12px;
	font-weight: 800;
	color: #ffffff;
}

/* v-btn-toggle como calc-type-grid: layout grid con minmax(120px, 1fr) */
.calc-type-grid.v-btn-toggle {
	display: grid !important;
	grid-template-columns: repeat(auto-fill, minmax(170px, 1fr)) !important;
	gap: 8px !important;
	background: transparent !important;
	border-radius: 0 !important;
	width: 100% !important;
}

/* v-btn como calc-type-chip: resetear estilos de vuetify */
.calc-type-chip.v-btn {
	height: auto !important;
	min-width: unset !important;
	max-width: unset !important;
	width: 100% !important;
	padding: 8px !important;
	border-radius: 1.5rem !important;
	border: 2px solid #e2e8f0 !important;
	background: #fff !important;
	margin: 0 !important;
	text-transform: none !important;
	letter-spacing: normal !important;
	flex-direction: column !important;
	align-items: center !important;
	justify-content: flex-start !important;
}

/* Forzar el slot interno de v-btn a columna centrada (::v-deep para scoped CSS) */
.calc-type-chip.v-btn::v-deep .v-btn__content {
	flex-direction: column !important;
	align-items: center !important;
	justify-content: center !important;
	gap: 6px;
	white-space: normal !important;
}

.calc-type-chip__icon {
	display: block;
}

.calc-type-chip__text {
	font-size: 10px;
	font-weight: 600;
	text-align: center;
	line-height: 1.3;
	white-space: normal;
	max-width: 100%;
	display: block;
}

.calc-type-chip.v-btn:hover:not(.calc-type-chip--active) {
	border-color: #a5b4fc !important;
	color: #4f46e5 !important;
	background: #ede9fe !important;
}

.calc-type-chip--active.v-btn {
	border-color: #6366f1 !important;
	background: linear-gradient(135deg, #6366f1, #818cf8) !important;
	color: #ffffff !important;
	box-shadow: 0 4px 12px rgba(99, 102, 241, 0.35) !important;
}

/* v-alert como old-price-toggle: ajustar layout interno */
.old-price-toggle.v-alert {
	margin-bottom: 0 !important;
}

.old-price-toggle .v-alert__content {
	width: 100%;
}

/* =============================================
   FILTER PANEL — Diseño premium
============================================= */
.filter-panel {
	border-radius: 16px;
	overflow: hidden;
	box-shadow: 0 4px 20px rgba(99, 102, 241, 0.12), 0 1px 4px rgba(0, 0, 0, 0.06);
	border: 1px solid #e0e7ff;
}

.filter-panel__header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 12px 20px;
	background: linear-gradient(135deg, #4f46e5 0%, #6366f1 60%, #818cf8 100%);
}

.filter-panel__header-left {
	display: flex;
	align-items: center;
}

.filter-panel__title {
	font-size: 13px;
	font-weight: 700;
	color: #ffffff;
	letter-spacing: 0.3px;
	line-height: 1.2;
}

.filter-panel__subtitle {
	font-size: 11px;
	color: rgba(255, 255, 255, 0.72);
	margin-top: 2px;
}

.filter-panel__toggle-btn {
	font-size: 11px !important;
	font-weight: 600 !important;
	opacity: 0.9;
	border: 1px solid rgba(255, 255, 255, 0.35) !important;
	border-radius: 8px !important;
	padding: 0 12px !important;
	transition: all 0.2s ease;
}

.filter-panel__toggle-btn:hover {
	opacity: 1;
	background: rgba(255, 255, 255, 0.15) !important;
}

.filter-panel__body {
	background: #fafbff;
	padding: 14px 20px 10px;
}

.filter-field-wrap {
	margin-bottom: 2px;
}

.filter-field-label {
	font-size: 11px;
	font-weight: 600;
	color: #6366f1;
	letter-spacing: 0.3px;
	text-transform: uppercase;
	margin-bottom: 4px;
	display: flex;
	align-items: center;
}

.filter-search-btn {
	border-radius: 8px !important;
	font-weight: 700 !important;
	letter-spacing: 0.3px;
	height: 36px !important;
	width: 100%;
}

/* IGV PREMIUN TOGGLE */
.igv-premium-toggle {
	background: #f8faff;
	border: 1px solid #e0e7ff !important;
	transition: all 0.3s ease;
}

.igv-premium-toggle:hover {
	border-color: #c7d2fe !important;
	background: #f0f4ff;
}

.igv-icon-box {
	display: flex;
	align-items: center;
	justify-content: center;
	box-shadow: 0 2px 8px rgba(99, 102, 241, 0.1);
}

.custom-switch ::v-deep .v-input--selection-controls__ripple {
	color: #4f46e5 !important;
}
</style>